import _ from 'lodash'
import {
  PRODUCT_WARRANTY_SCOPE_LIST,
  PRODUCT_WARRANTY_STATUS_MAP,
  PROPOSAL_TYPE
} from '@vzmi/shp_shared_compo/constants/proposal'
import {
  WARRANTY_SCOPE_OTHER
} from '../../../constants/proposalTypes'
import { getWarrantyFields } from '../../Proposal/Shared'
import { partialRemovedStringParser } from '../../../lib/parser'
import { APPLY_RADIO_TYPE, APPLY_ADD_OPTIONS_TYPE } from '../../../constants/batchProposals'
import { unescapeEntity } from '../../../../internal/lib/baseNormalizer'

export const getConvertedWarrantyFromFormListing = formListing => {
  const warrantyFields = getWarrantyFields('warranty')
  const { warranty: convertedWarranty } = _.reduce(warrantyFields, (warrantyWrap, field) => {
    const warrantyValue = _.get(formListing, field)
    // 判斷保固欄位非空值、空字串時需要轉換成 API 指定欄位
    if (_.size(warrantyValue) > 0) {
      switch (field) {
        case warrantyFields.warrantyCustomScopeField: {
          _.set(warrantyWrap, warrantyFields.warrantyScopeField, warrantyValue)
          break
        }
        case warrantyFields.warrantyScopeField: {
          const currentWarrantyScope = _.get(warrantyWrap, field)
          // 保固範圍有值時代表是選其他自訂保固內容
          if (_.isUndefined(currentWarrantyScope)) {
            _.set(warrantyWrap, field, warrantyValue)
          }
          break
        }
        default:
          _.set(warrantyWrap, field, warrantyValue)
          break
      }
    }
    return warrantyWrap
  }, { warranty: {} })
  return convertedWarranty
}

export const getConvertedCopyAndWarrantyListingParams = listing => {
  const {
    copy,
    isUpdateWithWarranty
  } = listing
  const warranty = getConvertedWarrantyFromFormListing(listing)
  const isUpdateCopyWithWarranty = (
    isUpdateWithWarranty &&
    !_.isEmpty(warranty)
  )
  const convertedListing = {
    // 判斷如果商品保證有填寫才需要送出
    ...(isUpdateCopyWithWarranty && { warranty }),
    copy
  }
  return convertedListing
}

export const getParamsList = (formValues, reviewStatus, duplicatedMap) => {
  const {
    applicant,
    listings = []
  } = formValues
  // 共用商品賣場不能修改所以預先剔除
  const filteredListings = _.filter(listings, listing => !(listing.id in duplicatedMap))
  const updateParamsList = _.map(filteredListings, listing => {
    const {
      proposal: {
        id: proposalId
      } = {}
    } = listing
    const convertedListing = {
      ..._.pick(listing, ['id']),
      ...getConvertedCopyAndWarrantyListingParams(listing)
    }
    const updateParams = {
      reviewStatus,
      applicant,
      id: proposalId,
      type: PROPOSAL_TYPE.UPDATE_COPY,
      listing: convertedListing
    }
    return updateParams
  })
  return updateParamsList
}

export const getCustomWarranty = warranty => {
  const {
    scope: warrantyScope,
    productStatus,
    ...restWarranty
  } = warranty
  let convertedWarrantyScope = warrantyScope
  let convertedWarrantyCustomScope = ''
  if (
    warrantyScope &&
    !_.includes(PRODUCT_WARRANTY_SCOPE_LIST, warrantyScope)
  ) {
    convertedWarrantyScope = WARRANTY_SCOPE_OTHER
    convertedWarrantyCustomScope = warrantyScope
  }
  let convertedProductStatus
  if (_.isUndefined(convertedProductStatus)) {
    convertedProductStatus = productStatus
  }

  // 產品狀態跟預設允許的不同時強制全部轉換成 null 由表單驗證阻擋讓 user 重選
  if (!(productStatus in PRODUCT_WARRANTY_STATUS_MAP)) {
    convertedProductStatus = null
  }
  const customWarranty = {
    ...restWarranty,
    ...(!_.isEmpty(convertedWarrantyCustomScope) && {
      custom_scope: convertedWarrantyCustomScope
    }),
    scope: convertedWarrantyScope,
    productStatus: convertedProductStatus
  }
  return customWarranty
}

export const getConvertedWarrantyListing = (listing, isUpdateWithWarranty = false) => {
  const warranty = _.get(listing, 'warranty', {})
  const customWarranty = getCustomWarranty(warranty)
  const currentIsUpdateWithWarranty = _.get(listing, 'isUpdateWithWarranty')
  const convertedWarrantyListing = {
    ...listing,
    warranty: customWarranty,
    isUpdateWithWarranty: _.isUndefined(currentIsUpdateWithWarranty)
      // 預設不展開"同時修改商品保證"
      ? isUpdateWithWarranty
      // 完成提案與返回修改時參考表單目前狀態決定是否展開"同時修改商品保證"
      : currentIsUpdateWithWarranty
  }
  return convertedWarrantyListing
}

export const getConvertedListings = (listings) => {
  const convertedListings = _.map(listings, listing => {
    const isUpdateWithWarranty = _.get(listing, 'proposal.listing.warranty', false)
    return getConvertedWarrantyListing(listing, isUpdateWithWarranty)
  })
  return convertedListings
}

export const getConvertedListingsAndModifiedList = (formListings, formApplyDetails) => {
  // 移除套用參數，用來判斷套用成功的訊息
  const modifiedList = []
  const newListings = _.map(formListings, item => {
    const listingCopy = _.get(item, 'copy', '')
    let newCopy = listingCopy || ''
    // 新增套用
    if (formApplyDetails.operates === APPLY_RADIO_TYPE.ADD) {
      // 重組賣場詳情(判斷加在上方還下方)
      if (formApplyDetails.options === APPLY_ADD_OPTIONS_TYPE.TOP) {
        newCopy = `${formApplyDetails.copy}\n<p>&nbsp;</p>${listingCopy}`
      } else {
        newCopy = `${listingCopy}<p>&nbsp;</p>\n${formApplyDetails.copy}`
      }
    } else { // 移除套用
      // 因為rich editor 複製(command+C)詳情資料，會將redux form值空白字元會轉譯&nbsp或&轉譯&amp...等
      // hack: 將 全部賣場詳情 及 套用詳情區 做decode html，統一格式比對
      newCopy = partialRemovedStringParser(unescapeEntity(listingCopy), unescapeEntity(formApplyDetails.copy))
      modifiedList.push({ id: item.id, replaced: !(newCopy === listingCopy) })
    }
    return { ...item, copy: newCopy }
  })
  return { newListings, modifiedList }
}
